import styled from "styled-components";

export const PageContentWrapper = styled.div`
  width: 100%;
  padding: 3rem;
  margin: 0 auto;
  max-width: 1800px;
`;
